import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-content-library-icon',
  templateUrl: './content-library-icon.component.html',
  styleUrls: ['./content-library-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLibraryIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
